import { render, staticRenderFns } from "./ProjectConfigMgmtView.vue?vue&type=template&id=4b0f9f47&scoped=true&"
import script from "./ProjectConfigMgmtView.vue?vue&type=script&lang=js&"
export * from "./ProjectConfigMgmtView.vue?vue&type=script&lang=js&"
import style0 from "./ProjectConfigMgmtView.vue?vue&type=style&index=0&id=4b0f9f47&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0f9f47",
  null
  
)

export default component.exports